import axios from '../utils/axios';

export default function getSearchFlaggedUsers(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/search/flagged-users`, { params })
    )
}